import { registrationOrdersURL, tournamentsURL } from "../app/api";
import gsApi from "../auth/auth";
import { getResponse } from "../helpers/JSONapi";
import { updateRemoteRegistrationOrder } from "./registrationAccess";

export const createAndPay = async (order, thunkAPI) => {
    const registration = order.registrationOrder;
    const registrationOrder = {
        accessEmail: registration.accessEmail,
        accessIdentifier: registration.accessIdentifier,
        accessValidated: registration.accessValidated,
        cardFirstName: registration.cardFirstName,
        cardLastName: registration.cardLastName,
        changeFeeAmount: registration.changeFeeAmount,
        customFieldResponses: registration.customFieldResponses,
        customFormValid: true,
        discountAmount: registration.discountAmount,
        discountCodes: registration.discountCodes,
        discountMessage: registration.discountMessage,
        donationOrderItems: registration.donationOrderItems,
        internationalCardUsed: registration.internationalCardUsed,
        payAtCourse: registration.payAtCourse,
        paymentOptionKey: registration.paymentOptionKey,
        paymentType: registration.paymentType,
        globalToken: registration.globalToken,
        stripeToken: registration.stripeToken,
        last4: registration.last4,
        cardName: registration.cardName,
        brand: registration.brand,
        registrantCoversFees: registration.registrantCoversFees,
        registrationOrderItems: registration.registrationOrderItems.map?.(
            (item, index) => {
                return {
                    accessGroupMemberId: item.accessGroupMemberId,
                    inProgressPlayers: item.inProgressPlayers,
                    inProgressSponsors: item.inProgressSponsors,
                    inProgressTournamentTeams: item.inProgressTournamentTeams.map?.(
                        (t) => {
                            return {
                                ...t,
                                id: null,
                                tournamentPackageId: item?.tournamentPackage?.id,
                            };
                        }
                    ),
                    index,
                    packageCost: item?.tournamentPackage?.cost,
                    quantity: item.quantity,
                    totalCost:
                        (item?.tournamentPackage?.cost ?? 0) * (item?.quantity ?? 0),
                    tournamentPackage: {
                        ...item.tournamentPackage,
                        tournament: registration.tournament.id,
                    },
                };
            }
        ),
        roundUpToggle: registration.roundUpToggle,
        status: "ready",
        totalCost: registration.totalCost,
        totalCostWithFees: registration.totalCostWithFees,
        totalPlatformFee: registration.totalPlatformFee,
        tournament: registration.tournament,
    };

    const fullOrder = {
        registrationCustomer: order.registrationCustomer,
        registrationOrder,
    };

    fullOrder["captcha_data"] = { ...order["captcha_data"] };
    fullOrder.saveCard = registration?.saveCard;

    return await getResponse(
        gsApi.post,
        `${registrationOrdersURL}/create-and-pay`,
        fullOrder,
        thunkAPI
    );
}

export const internationalCardCheck = async (data, thunkAPI) => {
    const { registrationOrder, cardInfo } = data;
    
    const response = await getResponse(
        gsApi.post,
        `${registrationOrdersURL}/international-card-check`,
        cardInfo,
        thunkAPI
    );

    const order = {
        ...registrationOrder,
        internationalCardUsed: response?.data?.["international_card"],
    };

    return updateRemoteRegistrationOrder(order, thunkAPI);
}

export const applyDiscount = async (discountSearch, thunkAPI) => {
    const { tournamentID, discountCode, registrationOrder } = discountSearch;
    const response = await getResponse(
      gsApi.get,
      `${tournamentsURL}/${tournamentID}/discount-code-search?discount_code=${encodeURIComponent(discountCode)}`,
      null,
      thunkAPI
    );

    if (!response?.id) {
      return response;
    }

    const update = { ...registrationOrder };
    update.discountCode = response

    return updateRemoteRegistrationOrder(update, thunkAPI);
  }

  export const calculateOrderPricing = async (registrationOrder, thunkAPI) => {
    const response = await getResponse(
      gsApi.post,
      `${registrationOrdersURL}/calculate-order-pricing`,
      registrationOrder,
      thunkAPI
    );
    if (response.payload === "") {
      return response;
    }
    return { ...registrationOrder, ...response };
  };